<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps([
  "modelValue",
  "filter",
  "type",
  "required",
  "placeholder",
  "disabled",
  "max",
  "label",
  "icon",
  "error",
  "autocomplete",
  "spellcheck",
  "autocapitalize",
  "rows",
  "cols",
]);
</script>

<template>
  <div class="flex w-full flex-col gap-1.5 normal-case">
    <label class="font-semibold text-sm text-primary" v-if="label">
      {{ label }}
    </label>
    <div class="relative flex w-full">
      <textarea
        :type="type || 'text'"
        :placeholder="placeholder"
        :maxlength="max"
        :required="required"
        :value="modelValue"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :spellcheck="spellcheck"
        :autocapitalize="autocapitalize"
        ref="input"
        :rows="rows"
        @input="emit('update:modelValue', $event.target.value)" />
    </div>
    <p class="text-redBase" v-if="error">{{ error }}</p>
  </div>
</template>

<style scoped>
textarea {
  @apply w-full rounded-2xl border border-border px-6 py-3 normal-case placeholder:text-primaryLightest focus:outline-none;
}
</style>
